import type { ReactNode } from "react";
import { cn } from "../lib/cn";

interface BrandLogoProps {
  /** Extra classes for spacing/sizing; overrides the default height. */
  className?: string;
}

/**
 * The DearBill brand lockup, served from the consuming app's `public/dearbill-logo.svg`.
 *
 * The intrinsic `width`/`height` keep the SVG's aspect ratio and reserve layout
 * space, so the image causes no layout shift.
 */
export function BrandLogo({ className }: BrandLogoProps): ReactNode {
  return (
    <img
      src="/dearbill-logo.svg"
      alt="DearBill"
      width={145}
      height={37}
      className={cn("h-7 w-auto", className)}
    />
  );
}
